var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-bar" }, [
    _c("nav", { staticClass: "bg-gray-800 py-4" }, [
      _c(
        "div",
        {
          staticClass:
            "w-full md:w-10/12 mx-auto text-white flex justify-between px-4 md:px-0"
        },
        [
          _c(
            "div",
            { staticClass: "flex items-center" },
            [
              _c(
                "router-link",
                { staticClass: "hover:text-white", attrs: { to: "/" } },
                [
                  _c("img", {
                    staticClass: "h-12",
                    attrs: { src: require("@/assets/logo.png"), alt: "" }
                  })
                ]
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "flex items-center" },
            [
              !_vm.$store.getters.isLoggedIn
                ? _c(
                    "router-link",
                    {
                      staticClass:
                        "bg-transparent border-transparent hover:border-gray-700 hover:text-white border-2 p-2 rounded inline-flex items-center justify-center",
                      attrs: { to: "/login" }
                    },
                    [
                      _c(
                        "svg",
                        {
                          staticClass: "h-5 fill-current mr-1",
                          attrs: { viewBox: "0 0 24 24" }
                        },
                        [
                          _c("path", {
                            attrs: {
                              d:
                                "M12,17C10.89,17 10,16.1 10,15C10,13.89 10.89,13 12,13A2,2 0 0,1 14,15A2,2 0 0,1 12,17M18,20V10H6V20H18M18,8A2,2 0 0,1 20,10V20A2,2 0 0,1 18,22H6C4.89,22 4,21.1 4,20V10C4,8.89 4.89,8 6,8H7V6A5,5 0 0,1 12,1A5,5 0 0,1 17,6V8H18M12,3A3,3 0 0,0 9,6V8H15V6A3,3 0 0,0 12,3Z"
                            }
                          })
                        ]
                      ),
                      _c("span", [_vm._v("Log In")])
                    ]
                  )
                : _vm._e(),
              _vm.$store.getters.isLoggedIn
                ? _c("div", { staticClass: "relative flex" }, [
                    _c(
                      "button",
                      {
                        staticClass:
                          "relative hover:border-gray-700 border-4 border-transparent rounded-full",
                        on: {
                          click: function($event) {
                            _vm.showAccountDropdown = !_vm.showAccountDropdown
                          }
                        }
                      },
                      [
                        _c("div", [
                          _c("img", {
                            staticClass: "rounded-full h-10",
                            attrs: {
                              src: _vm.$store.getters.tokenInfo.picture,
                              alt: ""
                            }
                          })
                        ])
                      ]
                    ),
                    _vm.showAccountDropdown
                      ? _c("div", {
                          staticClass: "fixed inset-0 z-40",
                          on: {
                            click: function($event) {
                              _vm.showAccountDropdown = false
                            }
                          }
                        })
                      : _vm._e(),
                    _vm.showAccountDropdown
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "absolute right-0 bg-white text-black z-50 w-56 mt-12 rounded p-4 shadow"
                          },
                          [
                            _c(
                              "h3",
                              {
                                staticClass: "text-gray-800 font-bold text-lg"
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$store.state.loggedInUser.name)
                                )
                              ]
                            ),
                            _c(
                              "h3",
                              {
                                staticClass:
                                  "text-gray-500 font-bold text-sm mb-4"
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$store.state.loggedInUser.email)
                                )
                              ]
                            ),
                            _c("div", { staticClass: "my-4 flex flex-col" }, [
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "w-full p-2 rounded hover:bg-gray-200 flex items-center justify-between",
                                  on: { click: _vm.goToProfile }
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "flex items-center" },
                                    [
                                      _c(
                                        "svg",
                                        {
                                          staticClass:
                                            "fill-current h-5 w-5 mr-2",
                                          attrs: { viewBox: "0 0 24 24" }
                                        },
                                        [
                                          _c("path", {
                                            attrs: {
                                              d:
                                                "M12,4A4,4 0 0,1 16,8A4,4 0 0,1 12,12A4,4 0 0,1 8,8A4,4 0 0,1 12,4M12,14C16.42,14 20,15.79 20,18V20H4V18C4,15.79 7.58,14 12,14Z"
                                            }
                                          })
                                        ]
                                      ),
                                      _c("span", [_vm._v("Account")])
                                    ]
                                  ),
                                  _c(
                                    "svg",
                                    {
                                      staticClass: "fill-current h-4 ml-4",
                                      attrs: { viewBox: "0 0 24 24" }
                                    },
                                    [
                                      _c("path", {
                                        attrs: {
                                          d:
                                            "M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z"
                                        }
                                      })
                                    ]
                                  )
                                ]
                              ),
                              _c(
                                "a",
                                {
                                  staticClass:
                                    "w-full p-2 rounded hover:bg-gray-200 flex items-center justify-between",
                                  attrs: {
                                    href: "https://webpart.store",
                                    target: "_blank"
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "flex items-center" },
                                    [
                                      _c(
                                        "svg",
                                        {
                                          staticClass:
                                            "fill-current h-5 w-5 mr-2",
                                          attrs: { viewBox: "0 0 24 24" }
                                        },
                                        [
                                          _c("path", {
                                            attrs: {
                                              d:
                                                "M17.9,17.39C17.64,16.59 16.89,16 16,16H15V13A1,1 0 0,0 14,12H8V10H10A1,1 0 0,0 11,9V7H13A2,2 0 0,0 15,5V4.59C17.93,5.77 20,8.64 20,12C20,14.08 19.2,15.97 17.9,17.39M11,19.93C7.05,19.44 4,16.08 4,12C4,11.38 4.08,10.78 4.21,10.21L9,15V16A2,2 0 0,0 11,18M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z"
                                            }
                                          }),
                                          _vm._v(" /> ")
                                        ]
                                      ),
                                      _c("span", [_vm._v("Go to website")])
                                    ]
                                  ),
                                  _c(
                                    "svg",
                                    {
                                      staticClass: "fill-current h-4 ml-4",
                                      attrs: { viewBox: "0 0 24 24" }
                                    },
                                    [
                                      _c("path", {
                                        attrs: {
                                          d:
                                            "M14,3V5H17.59L7.76,14.83L9.17,16.24L19,6.41V10H21V3M19,19H5V5H12V3H5C3.89,3 3,3.9 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V12H19V19Z"
                                        }
                                      })
                                    ]
                                  )
                                ]
                              )
                            ]),
                            _c(
                              "button",
                              {
                                staticClass:
                                  "border-gray-400 bg-white w-full p-2 border rounded hover:bg-gray-100 inline-flex items-center justify-center hover:shadow",
                                on: { click: _vm.logout }
                              },
                              [
                                _c(
                                  "svg",
                                  {
                                    staticClass: "h-5 w-5 fill-current mr-1",
                                    attrs: { viewBox: "0 0 24 24" }
                                  },
                                  [
                                    _c("path", {
                                      attrs: {
                                        d:
                                          "M12,17C10.89,17 10,16.1 10,15C10,13.89 10.89,13 12,13A2,2 0 0,1 14,15A2,2 0 0,1 12,17M18,20V10H6V20H18M18,8A2,2 0 0,1 20,10V20A2,2 0 0,1 18,22H6C4.89,22 4,21.1 4,20V10C4,8.89 4.89,8 6,8H7V6A5,5 0 0,1 12,1A5,5 0 0,1 17,6V8H18M12,3A3,3 0 0,0 9,6V8H15V6A3,3 0 0,0 12,3Z"
                                      }
                                    })
                                  ]
                                ),
                                _c("span", [_vm._v("Log Out")])
                              ]
                            )
                          ]
                        )
                      : _vm._e()
                  ])
                : _vm._e()
            ],
            1
          )
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }